import { render } from "./UserBar.vue?vue&type=template&id=6ff64e48"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff64e48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff64e48', __exports__)) {
    api.reload('6ff64e48', __exports__)
  }
  
  module.hot.accept("./UserBar.vue?vue&type=template&id=6ff64e48", () => {
    api.rerender('6ff64e48', render)
  })

}


export default __exports__